document.addEventListener("DOMContentLoaded", () => {
  const container = document.getElementById("scrollText");
  const paragraphs = Array.from(container.querySelectorAll("p"));
  let allLines = [];
  paragraphs.forEach((paragraph) => {
    // Step 1: wrap each word
    const words = paragraph.innerText
      .split(/\s+/)
      .map((w) => `<span>${w} </span>`)
      .join("");
    paragraph.innerHTML = words;
    const wordSpans = Array.from(paragraph.querySelectorAll("span"));
    const lines = [];
    let currentTop = null;
    let currentWords = [];
    // Step 2: group into lines based on visual layout (offsetTop)
    wordSpans.forEach((word) => {
      const top = word.offsetTop;
      if (currentTop === null) currentTop = top;
      if (top !== currentTop) {
        lines.push(currentWords.map((w) => w.innerText).join(" "));
        currentWords = [];
        currentTop = top;
      }
      currentWords.push(word);
    });
    if (currentWords.length) {
      lines.push(currentWords.map((w) => w.innerText).join(" "));
    }
    // Step 3: replace paragraph with line-spans
    paragraph.innerHTML = lines
      .map((line) => `<span class="line">${line}</span>`)
      .join("");
    allLines.push(...paragraph.querySelectorAll("span.line"));
  });
  // Step 4: staggered IntersectionObserver
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const index = allLines.indexOf(entry.target);
        if (entry.isIntersecting) {
          // Staggered fade-in

          entry.target.classList.add("visible");
        } else {
          // Remove instantly on scroll-out
          entry.target.classList.remove("visible");
        }
      });
    },
    {
      threshold: 1,
      rootMargin: "50px 0px -40% 0px",
    }
  );
  allLines.forEach((line) => observer.observe(line));
});
